/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Beta(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Beta',
      'aria-hidden': true,
      focusable: false,
      width:  25 * scale,
      height: 7 * scale,
      viewBox: '0 0 25 7',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"m23.312 7.003-.562-1.67h-2.617l-.572 1.67H18L20.582 0h1.832L25 7.003zm-1.91-5.547h.094l.924 2.747h-1.95l.933-2.747zM3.392 7.003H0V0h3.302c1.466 0 2.34.665 2.34 1.747 0 .743-.592 1.388-1.366 1.495v.087c1 .064 1.727.763 1.727 1.67 0 1.224-1 2-2.613 2zM1.58 1.12v1.782h1.188c.854 0 1.32-.325 1.32-.888 0-.558-.435-.893-1.19-.893H1.58zm0 4.762h1.408c.91 0 1.403-.354 1.403-1.01 0-.64-.504-.98-1.435-.98H1.58zm14.598 1.12h-1.34v-5.75h-1.832V0h5.002v1.252h-1.83zm-4.173-1.25V7H7.003V0h5.002v1.252H8.583v1.636h3.23v1.16h-3.23V5.75h3.422z","fill":"currentColor","fillRule":"evenodd","fillOpacity":".85"}))
}
